import { useCallback, useMemo } from 'react'

import { useLiveChatSDK } from '@inno-sdk/livechat-sdk'
import { AppId } from '@inno-tools/container-bridge'
import { FullPageAppTemplate } from 'modules/app-registry/templates'
import { useLocation, useNavigate } from 'react-router-dom'
import { useHistory, useNavigationContext, useUserContext } from 'shared/hooks'

import { useAvailableApps } from '../hooks/useAvailableApps'

export const LiveChatApp = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const history = useHistory()
  const { user } = useUserContext()
  const { apps } = useAvailableApps()
  const { livechatState, setLivechatState } = useNavigationContext()
  const { livechat } = useLiveChatSDK()

  const handleNavigate = useCallback(
    ({ pathname: nextPathname }: { pathname: string }) => {
      const { pathname } = location
      if (pathname !== nextPathname) {
        navigate(nextPathname)
      }
    },
    [navigate, location]
  )

  const appProps = useMemo(
    () => ({
      user,
      history,
      appPath: apps[AppId.LIVE_CHAT].path,
      initialPath: location.pathname,
      livechat,
      onNavigate: handleNavigate,
      isWidget: false,
      livechatState,
      setLivechatState
    }),
    [
      user,
      livechat,
      handleNavigate,
      livechatState,
      setLivechatState,
      apps,
      location,
      history
    ]
  )

  return (
    <FullPageAppTemplate
      appId={AppId.LIVE_CHAT}
      scope='livechat_v2'
      envKey={apps[AppId.LIVE_CHAT].runtimeEnvKey}
      entryPath='./LiveChatV2App'
      url={process.env.REACT_APP_LIVE_CHAT_V2_APP_DEV_PATH}
      appName={apps[AppId.LIVE_CHAT].name}
      appProps={appProps}
    />
  )
}
